module.exports = __webpack_public_path__ + "img/0Q3A2889_L_WoodMatted.a71e4bb5.jpg";